import { t } from '@/i18n';
import { z } from 'zod';

const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

export const modalFormSchema = z.object({
  title: z.string().min(1, t('pages.application_history_gallery.components.photo_gallery_edit_modal.schema.required')),
  description: z.string().min(1, t('pages.application_history_gallery.components.photo_gallery_edit_modal.schema.required')),
  team_uuid: z.string().optional(),
  credit: z.string().optional(),
  file: z
    .any()
    .refine(
      file => (file && ACCEPTED_IMAGE_TYPES.includes(file.type)) || !file,
      t('pages.application_history_gallery.components.photo_gallery_edit_modal.schema.required_image'),
    ),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
